import React from 'react';
import { CDN_URL } from '@utils/constants/url.constants';

const NotificationError = ({ isJC }: { isJC?: boolean | null }) => {
  return (
    <div
      className={`${
        isJC === false
          ? 'max-md:absolute max-md:top-1/2 max-md:left-1/2 max-md:-translate-x-1/2 max-md:-translate-y-1/2'
          : ''
      } w-full max-md:p-6`}
      data-testid={'notification-error'}
    >
      {isJC === false && (
        <img
          src={`${CDN_URL}assets/images/notification-error.svg`}
          alt={''}
          className={'mx-auto block w-[187px] mb-3'}
        />
      )}
      <p
        className={'text-primary-navyblue font-black text-lg mb-3 text-center'}
      >
        Something went wrong
      </p>
      <p className={'text-center text-neutral-pencil leading-5'}>
        We're fixing our servers as fast as we can. Take a break and try again
        later.
      </p>
    </div>
  );
};

export default NotificationError;
